var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import { fileToBase64 } from '@/support/String';
import { Media } from '@/models/Media';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import ErrorHandler from '@/support/ErrorHandler';
import LoaderCard from '@/components/loader-card/LoaderCard';
let CreateDialogMedia = class CreateDialogMedia extends Vue {
    constructor() {
        // #endregion
        super(...arguments);
        // #region @Refs
        // #endregion
        // #region Class properties
        this.file = null;
        this.fileName = '';
        this.fileString = '';
        this.inputElement = null;
        this.isDisplayingFileDialog = false;
        this.isDocument = false;
        this.isUploadingFile = false;
        // #endregion
        // #region @Watchers
        // #endregion
    }
    // #region Getters & Setters
    get getTempFile() {
        if (!this.fileString.length) {
            return '';
        }
        return this.fileString;
    }
    get dialogOptions() {
        return {
            title: this.$t('portfolio.dialog.fileSizeExceededTitle').toString(),
            text: this.$t('portfolio.dialog.fileSizeExceededMessage').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.file = null;
                        this.fileString = '';
                        this.fileName = '';
                        if (this.inputElement) {
                            this.inputElement.removeAttribute('value');
                            this.inputElement.setAttribute('value', '');
                        }
                    },
                },
            },
        };
    }
    // #endregion
    // #region Lifecycle Hooks / Init
    // #endregion
    // #region Class methods
    inputChanged(event) {
        const files = event.target.files;
        this.inputElement = event.target;
        if (files === null || !files.length) {
            return;
        }
        if (this.calculateFileSize(files[0].size) > 250) {
            this.isDisplayingFileDialog = true;
            return;
        }
        fileToBase64(files[0]).then((encodedFile) => {
            this.fileString = encodedFile;
        });
        this.file = files[0];
        this.file.type.includes('application/vnd.openxmlformats-officedocument') ? this.isDocument = true : this.isDocument = false;
    }
    createPayload() {
        return {
            file: this.file,
            ...this.mediaFilters,
        };
    }
    close() {
        this.$emit('input', false);
    }
    clear() {
        this.file = null;
        this.fileString = '';
        this.fileName = '';
        if (this.inputElement) {
            this.inputElement.removeAttribute('value');
            this.inputElement.setAttribute('value', '');
        }
    }
    // #endregion
    // #region Async methods
    create() {
        this.isUploadingFile = true;
        new Media()
            .create(this.createPayload())
            .then((response) => {
            if (response) {
                this.clear();
                this.$emit('input', false);
                this.$emit('uploaded');
                this.isUploadingFile = false;
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    calculateFileSize(bytes) {
        return Math.ceil(bytes / 1000000);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], CreateDialogMedia.prototype, "mediaFilters", void 0);
CreateDialogMedia = __decorate([
    Component({
        components: {
            AsyncSelect,
            LoaderCard,
        },
    })
], CreateDialogMedia);
export default CreateDialogMedia;
